





















import { JobTake5Check } from '@/models/jobTake5/jobTake5Check';
import User from '@/models/user';
import { vxm } from '@/stores';
import Nullable from '@/types/nullable';
import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({})
export default class Take5Details extends Vue {
  @Prop({ type: Object, default: null }) public take5!: Nullable<JobTake5Check>;

  private expanded: boolean = false;
  private userDisplayName: string = vxm.user.displayName;
  private userID: number = vxm.user.id;
  private date: Date = new Date();
  
  get dateString() {
    var dd = this.date.getDate();
    var mm = this.date.getMonth() +1;
    var yyyy = this.date.getFullYear();
    var ddmmyyyy = dd + '-' + mm.toString().padStart(2, '0') + '-' + yyyy;
    this.take5.date = ddmmyyyy;
    return ddmmyyyy;
  }
  
  textRequired(v: string) {
    if(v == null || v.length == 0){
      return "Cannot be left blank";
    }

    return true;
  }
}

